import styled from 'styled-components';

const AppServiceStyle = styled.div`
	svg {
		width: 100% !important;
		height: 100% !important;
		position: absolute !important;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
`;

export default AppServiceStyle;
